import {Injectable} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzNotificationService} from 'ng-zorro-antd/notification';

@Injectable()
export class GnMessageService {

  constructor(private messageService: NzMessageService,
              private notificationService: NzNotificationService) {
  }

  success(content: string): void {
    this.messageService.success(content);
  }

  error(content: string): void {
    this.notificationService.error('错误', content);
  }

  warn(content: string): void {
    this.notificationService.warning('提示', content);
  }

  clean(): void {
    this.messageService.remove();
    this.notificationService.remove();
  }

}
